import React, { useEffect } from "react";

const HeroSection = () => {
  useEffect(() => {
    const handleScroll = () => {
      const video = document.querySelector(".parallax-video");
      const scrollY = window.scrollY;

      // Adjust the transform property to simulate parallax
      if (scrollY < 500) {
        video.style.transform = `translateY(${scrollY * 0.3}px)`;
      }
    };

    // Add scroll event listener
    window.addEventListener("scroll", handleScroll);

    // Cleanup on unmount
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <section className="relative h-screen bg-black text-white flex items-center justify-center overflow-hidden">
      {/* Video Background with Parallax Effect */}
      <video
        className="absolute inset-0 w-full h-full object-cover opacity-30 parallax-video"
        autoPlay
        muted
        loop
      >
        <source src="/assets/video/background.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      {/* Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black via-transparent to-black opacity-80"></div>

      {/* Content */}
      <div className="relative z-10 text-center px-6">
      <h1 className="text-5xl md:text-6xl font-bold tracking-wide mb-6 bg-gradient-to-r from-[#1C9BF8] to-[#0D47A1] bg-clip-text text-transparent leading-[1.2] pb-3">
        Mobile Valeting <span className="text-white">&</span> Detailing
      </h1>
        <p className="text-lg md:text-xl max-w-3xl mx-auto mb-8 text-gray-300">
        We bring professional valeting and detailing to your doorstep across Colchester and Essex, ensuring a showroom shine for all vehicles.
        </p>
        <a
          href="#services"
          className="bg-gradient-to-r from-[#1C9BF8] to-[#0D47A1] text-white py-3 px-10 rounded-full font-semibold shadow-lg hover:scale-105 transition-transform duration-300"
        >
          Explore Services
        </a>
      </div>
    </section>
  );
};

export default HeroSection;
